import { useFormatMessage } from '../../../intl/intl';

export function useMainKanbanCardLang(props: Props) {
  const {
    isInCooking,
    isMarketPlace = false,
    showRTInfo = false,
    isRTNotifyAvailable = false,
    isPickup = false,
    hasMoreOrdersReady = false,
    numberOfOrdersNotReady = 0,
    buttonReadyPercentage = 0,
  } = props;

  const isOrderToDeliver = isMarketPlace || isPickup || isRTNotifyAvailable;
  const hasMoreOrdersNotReady = numberOfOrdersNotReady !== 0;

  const waitingFor = useFormatMessage({
    id:
      numberOfOrdersNotReady > 1
        ? 'pendingToDeliverKanbanCard.toWaitFor.plural'
        : 'pendingToDeliverKanbanCard.toWaitFor.single',
  });

  const rtBtn = useFormatMessage({
    id: isRTNotifyAvailable
      ? 'ordersKanban.rtState.notify'
      : 'ordersKanban.rtState.locate',
  });

  const orderIsMarketplaceTextId = isInCooking
    ? 'cookingKanbanCardMarketplace.buttonText'
    : 'pendingToDeliverKanbanCard.marketplaceButtonText';
  const orderNotMarketplaceToDeliverTextId = hasMoreOrdersReady
    ? 'orderDetailDialogActionsBox.pendingToDeliverButtonText.multiple'
    : 'orderDetailDialogActionsBox.pendingToDeliverButtonText.single';
  const orderNotMarketplaceTextId = isInCooking
    ? 'cookingKanbanCard.buttonText'
    : orderNotMarketplaceToDeliverTextId;
  const orderCTABtn = useFormatMessage({
    id: isMarketPlace ? orderIsMarketplaceTextId : orderNotMarketplaceTextId,
  });
  const showOrderCTABtn =
    isInCooking || (!hasMoreOrdersNotReady && isOrderToDeliver);

  const productConfirmationCode = useFormatMessage({
    id: 'orderDetailDialogActionsBox.productConfirmationCode',
  });

  const rtWaitingDetails = useFormatMessage({
    id: 'orderDetailDialogBagsDrinksBox.mandatoryInput.rtWaitingDetails',
  });

  const completeOrderDetailText = useFormatMessage({
    id: 'orderDetailDialogBagsDrinksBox.mandatoryInput.completeOrderDetails',
  });

  const orderReadyText = useFormatMessage({
    id: 'adoption.orderReady',
  });
  const orderReadyDisclaimer = useFormatMessage({
    id: 'adoption.orderReadyDisclaimer',
  });
  const orderReadyButtonReadyText = useFormatMessage(
    { id: 'orderDetailDialogActionsBox.orderReadyButtonDisclaimerText' },
    { percentage: buttonReadyPercentage },
  );

  return {
    waitingFor: hasMoreOrdersNotReady ? waitingFor : '',
    rtBtn: !hasMoreOrdersNotReady && showRTInfo ? rtBtn : '',
    orderCTABtn: showOrderCTABtn ? orderCTABtn : '',
    productConfirmationCode,
    mandatoryInput: { rtWaitingDetails, completeOrderDetailText },
    orderReadyAdoption: {
      text: orderReadyText,
      disclaimer: orderReadyDisclaimer,
    },
    orderReadyButtonReadyText,
  };
}

interface Props {
  isInCooking: boolean;
  showRTInfo: boolean;
  isMarketPlace: boolean;
  isRTNotifyAvailable: boolean;
  isPickup: boolean;
  hasMoreOrdersReady: boolean;
  numberOfOrdersNotReady: number;
  buttonReadyPercentage: number;
}
